import enLocale from "element-ui/lib/locale/lang/en";
console.log(enLocale, 444);
const en = {
  ...enLocale,
};
export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js